module.exports = __webpack_public_path__ + "static/img/logo_all_blue.0a8b348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_all_blue.png
// module id = HTMS
// module chunks = 1